import { useState, useRef, useEffect } from 'react';
import { API_ENDPOINTS, HUB_VIEW_ENDPOINTS } from '../../pages/utils/endpoints';
import { http_delete, http_get } from '../../pages/utils/api_client';

// Shared material row/card actions (view, edit, copy link, copy embed, duplicate,
// delete, kebab menu). Extracted so the grid Card and the table MaterialRow share
// identical behavior instead of duplicating it.
export default function useMaterialActions({ item, baseUrl, companySlug, setUpdatedData }) {
  const { name, material_type, slug } = item;
  const [menuVisible, setMenuVisible] = useState(false);
  const [copyVisible, setCopyVisible] = useState(false);
  const menuRef = useRef(null);

  const navPublishedView = () => { window.location.pathname = `${baseUrl}`; };
  const navEditView = () => { window.location.pathname = `${baseUrl}/edit`; };
  const toggleMenu = () => setMenuVisible((v) => !v);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setMenuVisible(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const refreshCategory = () => {
    const category = material_type === 'Walkthrough' ? 'walkthroughs' : String(material_type).toLowerCase();
    http_get(API_ENDPOINTS.GET_LEARNING_MATERIALS, { category })
      .then((res) => setUpdatedData && setUpdatedData(res.data));
  };

  const handleLinkCopy = ({ iframe = false } = {}) => {
    const link = `${window.location.origin}${HUB_VIEW_ENDPOINTS.VIEW_MATERIAL(companySlug, slug)}`;
    if (iframe) {
      navigator.clipboard.writeText(`<iframe src="${link}" height="400" width="100%" title="${name}" frameborder="0"></iframe>`);
    } else {
      navigator.clipboard.writeText(link);
    }
    setMenuVisible(false);
    setCopyVisible(true);
    setTimeout(() => setCopyVisible(false), 2000);
  };

  const handleDelete = () => {
    if (!confirm(`Are you sure you want to delete this material: ${name}?`)) return;
    http_delete(API_ENDPOINTS.DELETE_MATERIAL(slug))
      .then((res) => {
        if (res && res.data && res.data.message) { alert(res.data.message); refreshCategory(); }
        else { alert(res.data.error); }
      });
  };

  const handleDuplicate = () => {
    http_get(API_ENDPOINTS.DUPLICATE_LEARNING_MATERIAL(slug))
      .then((res) => {
        if (res && res.data && res.data.message) { alert(res.data.message); refreshCategory(); }
        else { alert(res.data.error); }
      })
      .catch((err) => alert(err?.response?.data?.error || err?.response?.data?.message || 'Unable to duplicate material.'));
  };

  return {
    menuVisible, copyVisible, menuRef,
    navPublishedView, navEditView, toggleMenu,
    handleLinkCopy, handleDelete, handleDuplicate
  };
}
